//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      user_drop_menu_show: false,
    };
  },
  mounted() {
    // document.addEventListener("click", (e) => {
    //   let s1 = this.$refs.s1;
    //   if (!s1.contains(e.target)) {
    //     this.user_drop_menu_show = false;
    //   }
    // },
    //   true
    // );
  },
  methods: {
    onClose() {
      this.user_drop_menu_show = false;
      this.$emit("onCloseDropMenuHandle");
    },
  },
};
